var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6316 14.5455H4.10526V4.36364H11.6316M11.6316 2.90909H4.10526C3.74234 2.90909 3.39427 3.06234 3.13764 3.33512C2.88101 3.6079 2.73684 3.97787 2.73684 4.36364V14.5455C2.73684 14.9312 2.88101 15.3012 3.13764 15.574C3.39427 15.8468 3.74234 16 4.10526 16H11.6316C11.9945 16 12.3426 15.8468 12.5992 15.574C12.8558 15.3012 13 14.9312 13 14.5455V4.36364C13 3.97787 12.8558 3.6079 12.5992 3.33512C12.3426 3.06234 11.9945 2.90909 11.6316 2.90909ZM9.57895 0H1.36842C1.00549 0 0.65743 0.153246 0.400801 0.426027C0.144172 0.698807 0 1.06878 0 1.45455V11.6364H1.36842V1.45455H9.57895V0Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.465bfdc31837e75f9ae936c7230c29d9.svg";
export { ForwardRef as ReactComponent };